import Vue from 'vue';
import BasicBlock from './BasicBlock';
import { SmartSuggestV4 } from '../../../../declarations/request';
import { InteractionBlockTypes } from '../../services/HandleInteractionService';
import VendorImage from './VendorImage';

export enum VendorImagesStyle {
    off = 'off',
    beforeText = 'beforeText',
    afterText = 'afterText',
    imageOnly = 'imageOnly',
}

export default Vue.component('smart-suggest-vendor', {
    template: `
    <smart-suggest-block class="fl-as-vendor" :icon="assets.iconVendor" :name="config.blocks.vendor"
                         v-if="config.blocks.vendor && vendors.length > 0">
      <ul class="fl-as-smart-suggest-list-container fl-as-vendor-list-container">
        <li class="fl-as-smart-suggest-list-option fl-as-vendor-list-option" v-for="vendor in vendors"
            @click="selectValue(vendor)">
          <div class="fl-as-vendor-item">
            <vendor-image
                v-if="vendorImageBeforeText || vendorImageOnly"
                :class="{'fl-pure-1-3': vendorImageBeforeText}"
                :imageUrl="vendor.imageUrl"
            />
            <p v-if="!vendorImageOnly"
               :class="{ 'fl-pure-2-3': vendorImageEnabled }"
               class="fl-as-vendor-text"
               v-html="getHighlightedName(vendor.text)"
            />
            <vendor-image
                v-if="vendorImageAfterText"
                class="fl-pure-1-3"
                :imageUrl="vendor.imageUrl"
            />
          </div>
        </li>
      </ul>
    </smart-suggest-block>
  `,
    inject: ['config', 'HandleInteractionService', 'HandleShopInteractionService', 'assets', 'utils'],
    props: { vendors: Array },
    components: {
        basic: BasicBlock,
        VendorImage,
    },
    computed: {
        vendorImageBeforeText(): boolean {
            return this.config.assistedSuggest.config.vendorImageStyle === VendorImagesStyle.beforeText;
        },
        vendorImageAfterText(): boolean {
            return this.config.assistedSuggest.config.vendorImageStyle === VendorImagesStyle.afterText;
        },
        vendorImageOnly(): boolean {
            return this.config.assistedSuggest.config.vendorImageStyle === VendorImagesStyle.imageOnly;
        },
        vendorImageEnabled(): boolean {
            return this.vendorImageBeforeText || this.vendorImageAfterText || this.vendorImageOnly;
        },
    },
    methods: {
        getHighlightedName(vendor: string): string {
            return this.config.assistedSuggest.config.highlightMatchesInSuggestions
                ? this.utils.generateHighlightedHtml(vendor, this.HandleShopInteractionService.getActiveInputValue())
                : this.utils.escapeUserProvidedText(vendor);
        },
        selectValue(vendor: SmartSuggestV4.VendorSuggestion): void {
            void this.HandleInteractionService.byBlock(InteractionBlockTypes.vendor).withValue(vendor.text).trackAndSubmit();
        },
    },
});
